import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledDynamics = styled.span<{
  $positive?: boolean;
  $negative?: boolean;
}>`
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  line-height: 1.2;
  white-space: nowrap;
  ${pickThemeFontStyles('12', '18', 'SEMI_NORMAL')};
  color: ${({ $positive, $negative }) => {
    if ($positive) return COLORS.GREEN;
    if ($negative) return COLORS.RED;
    return COLORS.GRAY_PRIMARY;
  }};
`;

export const StyledArrow = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 0.85em;
  font-size: 0.95em;
  line-height: 1;
`;
